import "../../App.scss";
import React, { useEffect } from "react";
import Banner from "./main-banner/Banner.js";
import Header from "./Header/Header.js";
import { useWeb3React } from "@web3-react/core";
import { useHistory } from "react-router-dom";
function Landing() {
  const history = useHistory();
  const { account } = useWeb3React();
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   if (account) {
  //     history.push("/claimall");
  //   }
  // }, [account]);
  return (
    <>
      <Header />
      <Banner />
    </>
  );
}

export default Landing;
